import { createContext } from "react";
export const Direction = {
    LTR: "ltr",
    RTL: "rtl",
};
export const Environment = {
    live: "live",
    test: "test",
    preview: "preview",
};
export const PageMetadataContext = createContext({
    locale: "en-us",
    dir: Direction.LTR,
    environment: Environment.live,
});
//# sourceMappingURL=PageMetadataContext.js.map